import { createContext, useContext, useEffect, useState } from "react";
import { cachedGet, invalidateCached } from "./sharedData";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const data = await cachedGet("/auth/me", 5 * 60000);
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setAuthChecked(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    invalidateCached("");
    if (data?.token) localStorage.setItem("pm_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async ({ email, password, name, role, invite_code }) => {
    const { data } = await api.post("/auth/register", { email, password, name, role, invite_code });
    if (data?.token) localStorage.setItem("pm_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const acceptPortalInvite = async (token, password, lang) => {
    const { data } = await api.post(`/portal/invite/${token}/accept`, { password, lang });
    if (data?.token) localStorage.setItem("pm_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    invalidateCached("");
    localStorage.removeItem("pm_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, authChecked, login, register, logout, acceptPortalInvite }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
